<template>
    <vx-card no-shadow title="Documents" class="mt-5">
      <div class="flex flex-col md:flex-row justify-between gap-y-4">
        <a-radio-group v-model="type_file" button-style="solid" style="white-space: nowrap">
          <a-radio-button :value="'all'" @click="filterStatus(undefined,'all')">
            All
          </a-radio-button>
          <a-radio-button :value="false" @click="filterStatus('isnull',false)">
            Files
          </a-radio-button>
          <a-radio-button :value="null" @click="filterStatus('=',null)">
            Folders
          </a-radio-button>
        </a-radio-group>
        <div class="flex justify-between gap-2">
          <a-button  type="primary"
                     ghost
                     icon="filter"
                     @click="showDrawer"
                     style="border-radius: 3px !important;"
          >
            Filters
          </a-button>
          <a-dropdown v-if="hasPermission('document.create')">
            <a-menu slot="overlay" @click="menuItem">
              <a-menu-item key="1" @click="visibleFile = true;menu_item = '1';edit_mode = false">
                <feather-icon icon="FileIcon" svg-classes="w-5 h-5 text-primary" style="top: 3px"/>
                File Upload
              </a-menu-item>
              <a-menu-item key="2" @click="visibleFolder = true; menu_item = '2'">
                <feather-icon icon="FolderIcon" svg-classes="w-5 h-5 text-primary" style="top: 3px"/>
                Folder Upload
              </a-menu-item>
              <a-menu-item key="3" @click="visibleFile = true;menu_item = '3'">
                <feather-icon icon="FolderPlusIcon" svg-classes="w-5 h-5 text-primary" style="top: 3px"/>
                New Folder
              </a-menu-item>
            </a-menu>
            <a-button class="" type="primary" style="border-radius: 3px !important;"> New
              <a-icon type="down"/>
            </a-button>
          </a-dropdown>
        </div>
      </div>

      <a-breadcrumb class="flex mt-5">
        <a-breadcrumb-item :class="{'mb-3':folder_name.length === 0}">
          <a v-if="folder_name.length > 0" href="#" class="text-primary" @click="allFileFolder"> All files and folders</a>
<!--          <p class="p-0 m-0" v-else> All files and folders</p>-->
          <p class="p-0 m-0" v-else>{{ $t('All_files_and_folders') }}</p>
        </a-breadcrumb-item>
        <template v-for="(folder,index) in folder_name">
          <a-breadcrumb-item v-if="folder">
            <template class="space-x-2">
              <feather-icon icon="FolderIcon" type="filled"
                            svg-classes="w-5 h-5 text-primary stroke-current"></feather-icon>
              <a-button
                type="link"
                class="p-0 ml-2 link-breadcrumb"
                style="vertical-align: middle"
                @click="toFolderFile(folder,false)"
                :disabled="folder.id === folder_id"
              >
                {{ folder.name }}
              </a-button>
            </template>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>

      <XTable
        :model="model"
        ref="document"
        @search="handleSearchTbl"
        :options="{ placeholder:'Tags or folders',noContent: 'No document',is_row_selection: false,is_load_req: false,temp_row: null }"
      >
        <span slot="action" slot-scope="text,record" class="flex space-x-3">
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item v-if="hasPermission('document.get')" key="1" @click="editDocument(text.record)"><feather-icon icon="EditIcon" class="mr-4" svg-classes="w-4 h-4 text-success"/>Edit</a-menu-item>
              <a-menu-item v-if="hasPermission('document.delete')" key="2" @click="removeDocument(text.record)"><feather-icon icon="TrashIcon" class="mr-4" svg-classes="w-4 h-4 text-danger"/>Delete</a-menu-item>
              <a-menu-item v-if="hasPermission('document.create') && !text.record.file_url" key="3" @click="AddFileFolder(text.record)"><feather-icon icon="FileIcon" class="mr-4" svg-classes="w-4 h-4 text-primary"/>Add file</a-menu-item>
              <a-menu-item v-if="!text.record.file_url" key="4" @click="AddFolder(text.record)"><feather-icon icon="FolderIcon" class="mr-4" svg-classes="w-4 h-4 text-primary"/>Add folder</a-menu-item>
              <a-menu-item key="5" @click="moveDocs(text.record)"><feather-icon icon="FolderIcon" class="mr-4" svg-classes="w-4 h-4 text-warning"/>Move</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> Actions <a-icon type="down"/></a-button>
          </a-dropdown>
        </span>
        <span slot="names" slot-scope="text,record">
          <template v-if="text.record.file_url">
            <feather-icon :icon="formatFiles(text.record.file_url.toLowerCase())" type="filled" svg-classes="w-5 h-5 text-primary stroke-current" style="vertical-align: sub"></feather-icon>
            <a-icon :type="formatFiles(text.record.file_url.toLowerCase())" :style="{ fontSize: '16px', color: 'rgb(58, 61, 190)' }" />
            <a :href="text.record.file_url" @click="downloadPrivate(text.record.file_url)">
              <span class="underline text-sm cursor-pointer ml-2" style="white-space: nowrap">{{ text.record.name }}</span>
            </a>
          </template>
          <template v-else>
             <span class="flex items-center space-x-2">
                <feather-icon icon="FolderIcon" type="filled" svg-classes="w-5 h-5 text-primary stroke-current"
                              style="vertical-align: sub"></feather-icon>
                <a-button
                  type="link"
                  class="underline p-0 text-sm cursor-pointer"
                  style="white-space: nowrap"
                  @click="toFolderFile(text.record,true)"
                >
                  {{ text.record.name }}
                </a-button>
             </span>
          </template>
        </span>
        <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
          <a-popover>
            <template slot="content">
              <p>{{ text.record.matter.title }}</p>
            </template>
            <p style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 8rem;">
              {{ text.record.matter.title }}
            </p>
          </a-popover>
        </span>
        <span slot="comment" class="flex">
           <a-button type="link" icon="plus-circle" class="text-sm font-semibold">Add comment</a-button>
        </span>
        <span slot="createdAt" slot-scope="text,record">
          {{ text.record.file_info ? setDateFormat(text.record.file_info.created_at) : '' }}
        </span>
        <span slot="count" slot-scope="text,record" v-if="text.record.file_info">
          {{ text.record.file_info.download_count }}
        </span>
        <span slot="size" slot-scope="text,record" v-if="text.record.file_info">
          {{ (text.record.file_info.size_in_bytes / 1000000) < 1 ? Math.ceil((text.record.file_info.size_in_bytes/1000).toFixed(2)) + ' KB'  : (text.record.file_info.size_in_bytes / 1000000).toFixed(2) + ' MB' }}
<!--          {{ (text.record.file_info.size_in_bytes / 800000 ) < 1 ? text.record.file_info.size_in_bytes + ' Kb' : (text.record.file_info.size_in_bytes).toFixed(2) + ' MB'}}-->
        </span>
        <span slot="time" slot-scope="text,record">
          <a-button type="border" v-if="text.record.file_url">Add time</a-button>
        </span>
        <span slot="tags" slot-scope="text,record" v-if="text.record.tags">
          <template v-if="text.record.tags.length">
            <ATag v-for="tag in text.record.tags.split(',')">
               {{ tag }}
            </ATag>
          </template>
        </span>
      </XTable>

      <a-modal :title="menu_item === '1' ? 'File Upload' : 'New Folder' " :visible="visibleFile" :width="700" @cancel="cancel">
        <a-form :form="form" @submit.prevent="handleSubmit">
          <template v-if="menu_item === '1'">
            <a-form-item v-if="!edit_mode">
              <a-upload
                :fileList="fileList"
                class="w-full mt-5"
                action="https://api.ira-lex.com/storage/private/"
                :headers="headers"
                @change="handleChange"
                :remove="removeFile"
              >
                <a-button style="border-radius: 3px">
                  <a-icon type="upload"/>
                  Select File
                </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item label="File Url" v-show="false">
              <a-input
                v-decorator="['file_url']"
                placeholder="Enter Subject"
                autocomplete="none"
              />
            </a-form-item>
            <a-form-item label="File">
              <a-input
                v-decorator="['name',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                autocomplete="none"
                placeholder="Name"
                :disabled="!disabled_btn_docs"
              />
            </a-form-item>
          </template>
          <template v-else-if="menu_item === '3'">
            <a-form-item label="Folder name">
              <a-input
                v-decorator="['name',{ rules: [{ required: true, message: 'This field is required.' },{ required: false, pattern: /^[^.\r\n]+$/, message: 'The folder name cannot contain periods.' }] }]"
                autocomplete="none"
              />
            </a-form-item>
          </template>
          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            field="matter"
            label="Matters"
            class="self-center w-full"
            :is_include_matter="true"
            @selectSearch="handleSearch"
            placeholder="Search to matter"
          />
          <a-form-item label="Tags">
            <a-select
              mode="tags"
              style="width: 100%"
              placeholder="Tags"
              @change="handleTags"
              v-decorator="['tags']"
            >
              <a-select-option v-for="(tag,index) in tags" :key="index">
                {{ tag }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <div v-if="edit_mode ? hasPermission('document.edit') : hasPermission('document.create')" class="flex gap-x-2 mt-5">
            <a-button
              type="primary"
              html-type="submit"
              :disabled="(menu_item === '1' && !disabled_btn_docs)"
              style="border-radius: 3px !important;"
            >
              Save
            </a-button>
            <a-button type="primary" ghost @click="visibleFile = false" style="border-radius: 3px !important;">Cancel</a-button>
          </div>
        </a-form>
      </a-modal>

      <a-modal :width="600" title="Move" :visible="visibleMove" @cancel="CancelMove">
        <a-form :form="formMove" @submit.prevent="handleToMove">
          <a-alert
            :message="`The following item(s) will be moved to the ${ select_tree ? select_tree.title : 'selected' } folder:`"
            :description="temp_row ? temp_row.name : '--'"
            type="info"
            show-icon
          />
          <a-form-item>
            <a-directory-tree
              :replaceFields="{children:'child',title:'name',key:'id'}"
              :expandedKeys.sync="expandedKeys"
              :tree-data="folders"
              @select="onSelectFolder"
              class="mt-5"
            />
          </a-form-item>
          <div class="flex gap-x-2 mt-5">
            <a-button type="primary" :disabled="!select_tree" html-type="submit" style="border-radius: 3px !important">Move to this folder</a-button>
            <a-button type="primary" ghost @click="CancelMove" style="border-radius: 3px !important;">Cancel</a-button>
          </div>
        </a-form>
      </a-modal>

      <a-modal title="Folder Upload" :visible="visibleFolder" :width="700" @cancel="cancelFolder">
        <a-form :form="formFolder" @submit.prevent="handleUpload">
          <a-upload :file-list="folderList" directory :remove="handleRemove" @change="handleChangeFolder" :before-upload="beforeUpload">
            <a-button type="primary" ghost style="border-radius: 3px !important;"> <a-icon type="upload" /> Select Folder </a-button>
          </a-upload>
          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            field="matter"
            label="Matter"
            class="self-center w-full"
            :is_include_matter="true"
            placeholder="Search to matter"
          />
          <a-form-item label="Tags">
            <a-select
              mode="tags"
              style="width: 100%"
              placeholder="Enter your tags"
              @change="handleTags"
              v-decorator="['tags']"
            >
              <a-select-option v-for="(tag,index) in tags" :key="index">
                {{ tag }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <span v-if="edit_mode ? hasPermission('document.edit') : hasPermission('document.create')" class="flex gap-x-2 mt-5">
            <a-button
                     type="primary"
                     :disabled="folderList.length === 0"
                     style="border-radius: 3px !important;"
                     :loading="loadingFolder"
                     @click="handleUpload"
                   >
                    {{ loadingFolder ? 'Uploading' : 'Start Upload' }}
            </a-button>
            <a-button
              type="primary"
              ghost
              @click="visibleFolder = false"
              style="border-radius: 3px !important;"
            >
              Cancel
            </a-button>
          </span>
        </a-form>
      </a-modal>

      <a-modal :visible="visibleDocsSame" :footer="null" @cancel="visibleDocsSame = false">
        <div class="font-bold">
          You have uploaded a duplicate file, would you like to replace it?
        </div>
        <div class="flex gap-2 mt-2">
          <a-button type="primary" ghost @click="handlerReplaceDoc">Replace</a-button>
          <a-button type="primary" @click="handlerKeepAlive">Keep Both</a-button>
        </div>
      </a-modal>

      <deleteItem
        :url="`/document/${temp_row ? temp_row.id : ''}/`"
        :subject="temp_row ? (temp_row.is_folder ? 'Folder' :'File') : 'Doc'"
        :ele="$refs.document"
        :textExtra="true"
        ref="deleteItemDocument"
      />

      <Drawer
        ref="filterDocs"
        :form="form"
        :ele="$refs.document"
        :query="[
            { field : 'name'   , value : form.getFieldValue('name')   ,  condition: 'like' },
            { field : 'matter' , value : form.getFieldValue('matter') ,  condition: '=' },
            { field : 'tags'   , value : tagsValue ,  condition: '=' },
        ]"
      >
        <template>
          <a-form-item label="Name" has-feedback>
            <a-input
              v-decorator="['name']"
              placeholder="name"
              autocomplete="none"
            />
          </a-form-item>
          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            field="matter"
            label="Matter"
            class="self-center mt-8 md:mt-0 w-full"
            :is_include_matter="true"
          />
          <a-form-item label="Tags" has-feedback>
            <a-select
              mode="tags"
              style="width: 100%"
              placeholder="Tags"
              v-decorator="['tags']"
            >
              <a-select-option v-for="(tag,index) in tags" :key="index">
                {{ tag }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <div
            :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  direction:'rtl',
                  zIndex: 1,
               }"
          >
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important">
              Save filter
            </a-button>
          </div>
        </template>
      </Drawer>

    </vx-card>
</template>

<script>

import XTable from '../../components/x-table/XTable'
import * as TableCol from './docsTbl'
import axios from '@/axios'
import mixin from '../mixin/mixin'
import selectSearch from "@/views/forms/selectSearch";
import deleteItem from "@/views/communications/deleteItem";
import Drawer from "@/views/drawer/Drawer";

export default {
  name: "Documents",
  mixins: [mixin],
  props:{
    hasFilterContact:{
      type: Boolean,
      default: false
    },
    hasFilterMatter:{
      type: Boolean,
      default: false
    },
  },
  components: {
    Drawer,
    XTable,
    selectSearch,
    deleteItem
  },

  data() {
    return {
      formFolder    : this.$form.createForm(this, {name: 'coordinated'}),
      formMove      : this.$form.createForm(this, {name: 'coordinated'}),
      model         : null,
      visibleFile   : false,
      visibleMove   : false,
      visibleFolder : false,
      temp_row      : null,
      row           : undefined,
      edit_temp_row : undefined,
      fileList   : [],
      folderList : [],
      folders    : [],
      progress   : 0,
      menu_item  : '1',
      type_file  : 'all',
      folder_name: [],
      folder_id  : null,
      select_tree       : undefined,
      find_folder_id    : undefined,
      disabled_btn_docs : false,
      tags_hashtag      : undefined,
      tags: [],
      edit_mode: false,
      loadingFolder:false,
      headers: {
        Auth: localStorage.getItem("accessToken") || localStorage.accessToken,
        timeout: 30000
      },
      expandedKeys:[],
      visibleDocsSame: false,
      recordSameDoc: null
    }
  },

  created() {
    this.model = TableCol.default
  },

  watch: {
    async $route() {
      const {history: {current: {query: {folderId}}}} = this.$router
      if (!folderId) {
        this.folder_name = []
        this.$refs.document.query.parent = undefined
      } else {
        const findRecord = this.folder_name.find(item => item.id === Number(folderId))
        const ind = this.folder_name.indexOf(findRecord)
        if (ind > -1)
          this.folder_name.splice(ind + 1, this.folder_name.length - 1)
        this.$refs.document.query.parent = folderId
      }
      await this.$refs.document.fetch()
    }
  },

  methods: {

    showDrawer(){
      this.$refs.filterDocs.visible_drawer = true
    },

    CancelMove(){
      this.visibleMove  = false
      this.folders      = []
      this.expandedKeys = []
      this.select_tree  = null
      this.temp_row     = null
    },

    handleUpload() {
      this.formFolder.validateFields(async(err,values) => {
        if (!err) {
          try {
            this.loadingFolder = true
            const { folderList,tags_hashtag } = this
            const formData = new FormData();
            folderList.forEach(file => formData.append(file.webkitRelativePath, file))
            formData.append('tags', tags_hashtag || [])

            if (this.$route.query.folderId) {
              formData.append('parent', Number(this.$route.query.folderId))
            }

            if (values.matter)
              formData.append('matter', values.matter)
            await axios.post('/document/folder/', formData)
            this.visibleFolder = false
            this.folderList = []
            this.formFolder.resetFields()
            this.$notification['success']({
              message: 'Success',
              description: `Folder(s) added.`,
            })
            this.$refs.document.fetch().then(()=>{})
          } catch (e) {
            this.$notification['error']({
              message: 'Failed',
              description: `File Extension Not Allow.`,
            })
            throw e
          }finally {
            this.loadingFolder = false
          }
        }
      })
    },

    handleRemove(file) {
      const index = this.folderList.indexOf(file);
      const newFileList = this.folderList.slice();
      newFileList.splice(index, 1);
      this.folderList = newFileList;
    },
    beforeUpload(file,fileList) {
      this.folderList = [...this.folderList, file];
      return false;
    },
    formatFiles(format){
      if(format.includes('.mp4') || format.includes('.wmv') || format.includes('.mov') || format.includes('.flv'))
          return 'VideoIcon'
      else if(format.includes('.png') || format.includes('.jpg') || format.includes('.jpeg'))
          return 'ImageIcon'
      else if(format.includes('.pdf'))
          return 'file-pdf'
      else if(format.includes('.mp3') || format.includes('.ogg'))
          return 'MicIcon'
      else
          return 'FileIcon'
    },

    cancelFolder(){
      this.visibleFolder = false
      if (this.edit_mode){
       this.formFolder.resetFields()
      }
    },

    async getOneDocs(record){
      try{
        this.$vs.loading()
        const { data } = await axios.get(`/document/${record.id}/`)
        this.row = data
        data.matter ? data.matter = data.matter.title : undefined
        if(data.tags){
          const filter_hashtag = data.tags.split('#').filter(item=> item.length && item !== '#').map(item=>item.replace(',',''))
          data.tags = filter_hashtag
        }else{
          data.tags = undefined
        }
        this.$nextTick(()=>this.form.setFieldsValue(data))
      }finally {
        this.$vs.loading.close()
      }
    },

    editDocument(record){
      this.disabled_btn_docs = true
      record.file_url ? this.menu_item = '1' : this.menu_item = '3'
      this.edit_temp_row = record
      this.visibleFile = true
      this.edit_mode = true
      this.$nextTick(()=>this.getOneDocs(record))
    },

    handleSearchTbl(search){
      if(search === null || search === '')
        this.$refs.document.query.search = undefined
    },

    handleTags(tags){
      const tagsItem    = tags.map((tag)=> `#${tag}`)
      this.tags_hashtag = tagsItem.join()
    },

    async moveDocs(record){
      this.$vs.loading({ text: 'Getting information from the server.' })
      this.temp_row = record
      this.folder_name.length ? this.expandedKeys = this.folder_name.map(({id}) => id) : record.is_folder ? this.expandedKeys.push(record.id) : []
      await this.getFolder()
      this.$vs.loading.close()
      this.visibleMove = true
    },

    onSelectFolder(keys,event){
      this.select_tree = event.node
    },

    handleToMove(){
      this.formMove.validateFields(async (err,values)=>{
        const { temp_row,select_tree } = this
        if(!select_tree.eventKey){
          this.$message.error('Please select folder for share documents')
          return
        }
        if(!err){
          try{
            this.$vs.loading()
            await axios.put(`/document/${temp_row.id}/`,{
              parent   : select_tree.eventKey,
              file_url : temp_row.file_url || undefined,
              name     : temp_row.name || undefined,
              matter   : temp_row.matter ? temp_row.matter.id : undefined
            })
            this.select_tree = {}
            this.temp_row    = undefined
            this.visibleMove = false
            this.expandedKeys= []
            this.formMove.resetFields()
            this.$notification['success']({
              message: 'Success',
              description: `Document moved.`,
            })
            this.$refs.document.fetch().then(()=>{})
          }catch (e) {
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
            this.visibleMove = true
          }finally {
            this.$vs.loading.close()
          }
        }
      })

    },

    async downloadPrivate(url) {
      try {
        this.$vs.loading({text: 'Downloading file...'})
        const file      = url.split('/')
        const last_item = file[file.length - 1]
        const {data}    = await axios.get(`/storage/token/${last_item}`)
        window.location.href = `https://api.ira-lex.com/storage/private/${data.token}`
      } catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: `Please try again.`,
        });
      } finally {
        this.$vs.loading.close()
      }
    },

    async getDataTbl() {
      this.$refs.document.data = []
      await this.$refs.document.fetch()
    },

    async toFolderFile(record, addFolder) {
      this.folder_id = record.id
      if (addFolder) {
        this.folder_name.push(record)
      } else {
        const ind = this.folder_name.indexOf(record)
        this.folder_name.splice(ind + 1, this.folder_name.length - 1)
      }
      localStorage.setItem('folders', JSON.stringify(this.folder_name))
      this.$router.push({path: '/documents', query: {folderId: record.id}}).then(() => {})
      this.$refs.document.query = { parent : record.id, search : undefined, page : 1 }
      this.$refs.document.data = []
      //await this.getDataTbl()
    },

    async allFileFolder() {
      this.$router.push({path: '/documents'}).then(() => {})
      this.$refs.document.query.parent = undefined
      await this.getDataTbl()
    },

    AddFileFolder(record) {
      this.menu_item   = '1'
      this.temp_row    = record
      this.visibleFile = true
    },

    AddFolder(record) {
      this.menu_item   = '3'
      this.temp_row    = record
      this.visibleFile = true
    },

    menuItem(e) {
      this.edit_mode = false
      this.row = undefined
      this.fileList.length ? this.disabled_btn_docs = true : this.disabled_btn_docs = false
      this.menu_item = e.key
    },

    handleChange(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status === 'done') {
        this.disabled_btn_docs = true
        this.$message.success(`${info.file.name} file uploaded successfully`);
        this.form.setFieldsValue({
          name: info.file.name,
          file_url: info.file.response ? info.file.response.url : undefined
        })
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file} file upload failed.`);
      }
    },

    handleChangeFolder({file,fileList}){
      if (file.status === 'done') {
        this.folderList = fileList
        this.$message.success(`${file.name} folder uploaded successfully`);
      } else if (file.status === 'error') {
        this.$message.error(`${file.name} folder upload failed.`);
      }
    },

    removeFile() {
      this.disabled_btn_docs = false
      this.form.setFieldsValue({name: undefined})
    },

    checkDocumentSame(data) {
      const rows            = this.$refs.document.data
      const str_split       = data.name.split('.')
      const checkIncludeDoc = rows.filter(item =>item.name.startsWith(str_split[0]))
      if (this.edit_mode) return true
      if (checkIncludeDoc.length) return false
      return true
    },

    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.checkDocumentSame(values)) {
            try {
              this.$vs.loading()
              this.tags_hashtag === [] || this.tags_hashtag === "" ? values.tags = null : values.tags = this.tags_hashtag

              if (!this.temp_row && this.$route.query.folderId) {
                values.parent = Number(this.$route.query.folderId)
              }
              else if (this.temp_row) {
                if (this.temp_row.is_folder) values.parent = this.temp_row.id
                else values.parent = this.temp_row.parent
              }
              else {
                values.parent = undefined
              }

              if (this.edit_mode) {
                this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.row.matter.id
                await axios.put(`/document/${this.edit_temp_row.id}/`, values)
              } else await axios.post('/document/', values)
              this.matter_value = null
              this.fileList     = []
              this.menu_item    = '1'
              this.tags_hashtag = undefined
              this.temp_row     = null
              await this.$notification['success']({
                message: 'Success',
                description: `Document ${this.edit_mode ? 'updated' : 'created'} .`,
              });
              this.form.resetFields()
              this.visibleFile = false
              if(!this.edit_mode)
                this.$refs.document.query.query = []
              this.$refs.document.fetch().then(()=> {})
            } catch (e) {
              this.$notification['error']({
                message: 'error',
                description: `Document failed.`,
              });
            } finally {
              this.$vs.loading.close()
            }
          } else {
            this.visibleDocsSame = true
            this.recordSameDoc   = values
          }
        }
      })
    },

    async requestDoc(data) {
      try {
        await axios.post('/document/', data)
        this.form.resetFields()
        this.fileList        = []
        this.visibleDocsSame = false
        this.visibleFile     = false
        this.recordSameDoc   = null
        this.temp_row        = null
        this.$refs.document.fetch().then(()=> {})
      }catch (e) {
        throw e
      }
    },

    async handlerReplaceDoc() {
      try{
        this.$vs.loading()
        const {recordSameDoc} = this
        const rows            = this.$refs.document.data
        const findDoc         = rows.find(item => item.name === recordSameDoc.name)
        if (findDoc !== undefined) {
          this.tags_hashtag === [] || this.tags_hashtag === "" ? recordSameDoc.tags = null : recordSameDoc.tags = this.tags_hashtag
          if(this.$route.query.folderId && !this.temp_row)
            recordSameDoc.parent = Number(this.$route.query.folderId)
          else if(this.temp_row)
            recordSameDoc.parent = this.temp_row.parent
          else
            recordSameDoc.parent = undefined
          await axios.delete(`/document/${findDoc.id}/`)
          await this.requestDoc(recordSameDoc)
        }
      }catch (e) {
        this.$message.error('Server Error, Please try again')
        throw e
      }finally {
        this.$vs.loading.close()
      }
    },

    folderName(a,b) {
      console.log(a,b,'a,b a,b')
    },

    async handlerKeepAlive() {
      if (this.form.getFieldValue('name')) {
        try {
          this.$vs.loading()
          const {
            recordSameDoc ,
            menu_item
          }                       = this
          const rows              = this.$refs.document.data
          const pattern           = /\(([^)]+)\)/
          const str_split         = this.form.getFieldValue('name').split('.')
          const filterListSameDoc = rows.filter(row => row.name.startsWith(str_split[0]) && row.name.match(pattern)).map(({name}) => name)
          const listFileId        = filterListSameDoc.map(el => {
            const str = el.split('.')
            return Number(str[0].replace(/^.*\((.*?)\).*$/, "$1"))
          }).sort((a,b) => a - b)
          const countNumberDoc = `(${listFileId.length === 0 ? 1 : listFileId[listFileId.length - 1] + 1})`
          const nameFirstFile  = str_split[0] + countNumberDoc
          recordSameDoc.name   = menu_item === '1' ? nameFirstFile + '.' + str_split[1] : recordSameDoc.name + countNumberDoc
          this.tags_hashtag === [] || this.tags_hashtag === "" ? recordSameDoc.tags = null : recordSameDoc.tags = this.tags_hashtag
          if(this.$route.query.folderId && !this.temp_row)
            recordSameDoc.parent = Number(this.$route.query.folderId)
          else if(this.temp_row)
            recordSameDoc.parent = this.temp_row.parent
          else
            recordSameDoc.parent = undefined
          await this.requestDoc(recordSameDoc)
        }catch (e) {
          this.visibleDocsSame = true
          throw e
        }finally {
          this.$vs.loading.close()
        }
      }
      // this.form.getFieldValue('name')
    },

    removeDocument(record) {
      this.$refs.deleteItemDocument.open = true
      this.temp_row = record
    },

    async filterStatus(condition, value) {
      this.checkPagenation(this.$refs.document)
      const parent = this.$route.query.folderId
      this.$refs.document.query.parent = Number(parent) || null
      this.$refs.document.query.query = (value === 'all' ? [] : [{ field: 'file_info', condition: condition, value: value }])
      await this.$refs.document.fetch()
    },

    cancel() {
      this.visibleFile = false
      this.temp_row    = undefined
      if(this.edit_mode){
        this.form.resetFields()
      }
    },

    async getFolder() {
      const folderFirstChild = (child) => {
        if(child.length === 0)
          return
        child.forEach((item)=>{
          item.disabled = true
          folderFirstChild(item.child);
        })
      }
      const folderOtherChild = (item) => {
          if(item.child.length === 0)
            return
          item.child.forEach((item)=>{
            if(item.id === this.temp_row.id){
              item.disabled = true
              folderFirstChild(item.child);
            }
            folderOtherChild(item)
          })
      }
      const {data} = await axios.get('/document/list/folder/')
      data.forEach((item)=>{
        if(item.id === this.temp_row.id){
          item.disabled = true
          folderFirstChild(item.child)
        }else{
          folderOtherChild(item)
        }
      })
      this.folders = data;
    }
  },

  computed:{
    check_disabled(){
      if(!edit_mode){
        return this.menu_item === '1' && this.disabled_btn_docs === false
      }
    },
    tagsValue(){
      return this.form.getFieldValue('tags')
    }
  },

  async mounted() {
    const {history: {current: {query: {folderId}}}} = this.$router
    if (folderId) {
      this.folder_id = Number(folderId)
      this.folder_name = JSON.parse(localStorage.getItem('folders'))
      this.$refs.document.query.parent = folderId
    } else {
      this.folder_name = []
      this.$refs.document.query.parent = undefined
    }
    if(this.hasFilterContact && !folderId) {
      this.$refs.document.query.query = [{ field: 'matter__client__id',condition: '=',value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
    }
    if(this.hasFilterMatter && !folderId) {
      this.$refs.document.query.query = [{ field: 'matter__id',condition: '=',value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
    }
    if (this.$route.params.query) {
      this.$refs.document.query.search = this.$route.params.query
      this.$refs.document.query.page = 1
    }
    await this.$refs.document.fetch()
  }
}
</script>

<style>

@import "../style/style.css";

.last-edit {
  font-family: sans-serif;
}

.ant-btn-link, .text-indigo-600 {
  color: #3A3DBE
}

.docs-btn {
  padding: 0.5em 1em !important;
  border-radius: 4px !important;
}

[dir=ltr] .ant-modal-footer {
  display: none !important
}

.link-breadcrumb span {
  vertical-align: super
}

@media (max-width: 600px) {
  .btn_add {
    width: 70%;
    text-align: center;
    display: block;
    margin: auto;
  }
}

.ant-alert.ant-alert-info.ant-alert-with-description{
  border-radius: 3px !important;
}

.ant-alert-message{
  font-size: 1rem !important;
}

.ant-tag.ant-tag-has-color{
  border-radius: 3px !important;
}


</style>


<!--handleFolder(){-->
<!--this.formFolder.validateFields(async (err, values) => {-->
<!--if(!err){-->
<!--try{-->
<!--this.$vs.loading()-->
<!--const tags = this.tags_hashtag === [] || this.tags_hashtag === "" ? values.tags = null : values.tags = this.tags_hashtag-->
<!--const { data } = await axios.post('/document/',{ name: this.folder_name_system,tags: tags })-->
<!--this.upload_folder_files_list.map(item=>axios.post('/document/',{ parent: data.id , file_url: item.response.url ,name:item.name }))-->
<!--this.visibleFolder = false-->
<!--this.formFolder.resetFields()-->
<!--this.upload_folder_files_list = []-->
<!--await this.$notification['success']({-->
<!--message: 'Success',-->
<!--description: `Document ${this.edit_mode ? 'updated' : 'created'} .`,-->
<!--});-->
<!--this.$refs.document.fetch().then(()=> {})-->
<!--}catch (e) {-->
<!--this.$notification['error']({-->
<!--message: 'error',-->
<!--description: `Document failed.`,-->
<!--});-->
<!--this.visibleFolder = true-->
<!--}finally {-->
<!--this.$vs.loading.close()-->
<!--}-->
<!--}-->
<!--})-->
<!--},-->
